
<div class="material-story" fxFlexFill fxLayout="column" fxLayoutAlign="start stretch">
    <app-hero-title fxHide.lt-sm="true" class="w-100" title="MARIS Datasets"></app-hero-title>
    <div fxFlex fxLayout="column" fxLayoutAlign="center stretch" class="table-wrapper" ngClass.sm="sm" ngClass.xs="xs" ngClass.gt-sm="xl">
        <div fxFlex [ngClass.sm]="''" [ngClass.xs]="''" fxLayout="column" fxLayoutAlign="start stretch">
            <div ngClass.gt-sm="w-70" fxFlex ngClass.gt-sm="xl" class="table-desing border border-bottom-0">
                <div class="" fxLayout="row" fxLayoutAlign="space-between start">
                    <h5 class="title-table" ngClass.sm="sm" ngClass.xs="xs" ngClass.gt-sm="xl">Datasets</h5>
                    <div class="search-input-wrapper1" fxHide.lt-sm="true" fxLayout="row" fxLayoutAlign="start center" ngClass.sm="sm" ngClass.xs="xs" ngClass.gt-sm="xl">
                        <input fxFlex type="text" class="search-input" placeholder="Search all datasets" matInput (keyup)="filter($event)" />
                        <mat-icon matSuffix fxLayout="row" fxLayoutAlign="center center">
                            <svg xmlns="http://www.w3.org/2000/svg" class="icon-sm" viewBox="0 0 20 20" fill="currentColor">
                                <path fill-rule="evenodd" d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z" clip-rule="evenodd" />
                            </svg>
                        </mat-icon>
                    </div>
                </div>
                <div fxHide fxShow.xs class="xs-name" fxLayout="column" fxLayoutAlign="start start">
                    <div class="search-input-wrapper1" fxLayout="row" fxLayoutAlign="start center" ngClass.sm="sm" ngClass.xs="xs" ngClass.gt-sm="xl">
                        <input fxFlex type="text" class="search-input" placeholder="Search all datasets" matInput (keyup)="filter($event)" />
                        <mat-icon matSuffix fxLayout="row">
                            <svg xmlns="http://www.w3.org/2000/svg" class="icon-sm" viewBox="0 0 20 20" fill="currentColor">
                                <path fill-rule="evenodd" d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z" clip-rule="evenodd" />
                            </svg>
                        </mat-icon>
                    </div>
                </div>
                    <span ngClass.sm="sm" ngClass.xs="xs" ngClass.gt-sm="xl" style="font-style: italic; margin-left:3%; font-size: small;">
                        <input id="chkNetcdfId" type="checkbox" [(ngModel)]="enablechkNetCdf" [checked]="false" class="switch" />
                        By downloading data you agree to the IAEAs
                        <a style="color: blue" href="https://nucleus.iaea.org/Pages/Others/Disclaimer.aspx" target="_blank">Terms and Conditions.</a>
                    </span>

                    <mat-table ngClass.sm="sm"
                               ngClass.xs="xs"
                               ngClass.gt-sm="xl"
                               matSort
                               matSortActive="displayText"
                               matSortDirection="asc"
                               (matSortChange)="onSortChange($event)"
                               [dataSource]="loadedDatasets"
                               class="mat-primary-100 table">
                        <mat-accordion hideToggle="true" togglePosition="before" [displayMode]="'flat'" multi>
                            <!-- Position Column -->
                            <ng-container matColumnDef="expander">
                                <mat-header-cell *matHeaderCellDef class="" ngClass.sm="sm" ngClass.xs="xs" ngClass.gt-sm="xl">
                                    <div class="sample-text fw-bold">
                                        <button *ngIf="!showCollapseButton" class="expander-btn fw-bold" mat-button (click)="accordion.openAll()">Expand all</button>
                                        <button *ngIf="showCollapseButton" class="expander-btn fw-bold" mat-button (click)="accordion.closeAll()">Collapse all</button>
                                    </div>
                                </mat-header-cell>
                                <mat-cell *matCellDef="let element" ngClass.sm="sm" ngClass.xs="xs" ngClass.gt-sm="xl">
                                    <div class="sample-text fw-bold">
                                        <button class="expander-btn fw-bold" mat-icon-button (click)="toggleEpanelId(element.refId).open()">
                                            <mat-icon *ngIf="!getEpanelExpanded(element.refId)">expand_more</mat-icon>
                                            <mat-icon *ngIf="getEpanelExpanded(element.refId)">expand_less</mat-icon>
                                        </button>
                                    </div>
                                </mat-cell>
                            </ng-container>

                            <!-- Name Column -->
                            <ng-container matColumnDef="displayText">
                                <mat-header-cell fxHide.lt-sm="true" mat-sort-header disableClear="true" *matHeaderCellDef class="fw-bold p-0"> Name </mat-header-cell>
                                <mat-cell *matCellDef="let element" class="table-body">
                                    <mat-expansion-panel [id]="'ep-' + element.refId" class="mat-elevation-z0">
                                        <mat-expansion-panel-header [id]="element.refId">
                                            <mat-panel-title>
                                                <div class="sample-text">
                                                    {{ element.displayText }}
                                                </div>
                                            </mat-panel-title>
                                        </mat-expansion-panel-header>
                                        <p>{{ element.fullText }}</p>
                                        <div fxHide class="name-link" fxShow.lt-md>
                                            <a class="sample-text" href="{{ element.zoteroUrl }}" target="_blank">Link</a>
                                        </div>
                                        <div fxHide fxShow.xs class="xs-name" fxLayout="column" fxLayoutAlign="start start" fxLayoutGap="4px">
                                            <div fxLayout="column" fxLayoutGap="4px">
                                                <div *ngFor="let sampleTypeId of parseSampleTypes(element.sampleTypes)">
                                                    <a class="sample-type"
                                                       fxLayout="row"
                                                       fxLayoutAlign="start center"
                                                       fxLayoutGap="4px"
                                                       [routerLink]="['/explore/type', sampleTypeId, 'ref', element.refId]"
                                                       routerLinkActive="router-link-active">
                                                        <img class="sample-type-img" [src]="sampleTypeImage(sampleTypeId) | safe : 'url'" alt="" srcset="" />
                                                        <div class="sample-type-text">{{ sampleTypeLabel(sampleTypeId) }}</div>
                                                    </a>
                                                </div>
                                            </div>
                                            <!--<button class="download-csv" mat-button>
                                <span class="download-csv-text" (click)="openDialog(element.refId)">Download CSV</span>
                            </button>-->
                                            <a class="download-csv"
                                               fxLayout="row"
                                               fxLayoutAlign="start center"
                                               fxLayoutGap="4px"
                                               (click)="openDialog(element.refId);$event.preventDefault()"
                                               href='/datasets/{{element.refId}}.csv'
                                               routerLinkActive="router-link-active">
                                                <span class="download-csv-text">CSV</span>

                                            </a>

                                            <a *ngIf="showNetCDFbutton(element.refId)" class="download-csv" style="background: darkcyan;color:white;"
                                               fxLayout="row"
                                               fxLayoutAlign="start center"
                                               fxLayoutGap="4px"
                                               (click)="openNETCDFDialog(element.refId);$event.preventDefault()"
                                               href='/datasets/{{element.refId}}.nc'
                                               routerLinkActive=router-link-active>

                                                <span class="download-csv-text">NetCDF</span>
                                            </a>

                                        </div>
                                    </mat-expansion-panel>
                                </mat-cell>
                            </ng-container>

                            <!-- Publication Year Column -->
                            <ng-container matColumnDef="publicationYear">
                                <mat-header-cell fxHide.lt-sm="true" mat-sort-header disableClear="true" *matHeaderCellDef class="fw-bold"> Year </mat-header-cell>
                                <mat-cell fxHide.lt-sm="true" *matCellDef="let element" class="table-body">
                                    <div class="sample-text">
                                        {{ element.publicationYear }}
                                    </div>
                                </mat-cell>
                            </ng-container>

                            <!-- Link -->
                            <ng-container matColumnDef="zoteroUrl">
                                <mat-header-cell fxHide.lt-md *matHeaderCellDef class="fw-bold"> Reference </mat-header-cell>
                                <mat-cell fxHide.lt-md *matCellDef="let element" class="table-body">
                                    <a class="sample-text" href="{{ element.zoteroUrl }}" target="_blank">Link</a>
                                </mat-cell>
                            </ng-container>

                            <!-- Data types -->
                            <ng-container matColumnDef="sampleTypes">
                                <mat-header-cell *matHeaderCellDef class="sample-types-header fw-bold">
                                    Data types
                                    <mat-icon cdkOverlayOrigin #trigger="cdkOverlayOrigin" (click)="toggleSampleTypeFilter()">tune</mat-icon>
                                    <ng-template cdkConnectedOverlay
                                                 [cdkConnectedOverlayOrigin]="trigger"
                                                 [cdkConnectedOverlayOpen]="isSampleTypeFilterOpen"
                                                 (overlayOutsideClick)="overlayOutsideClick($event)">
                                        <div fxLayout="column" fxLayoutAlign="start stretch" class="sample-types-overlay-wrapper">
                                            <div class="close-button-wrapper">
                                                <button mat-icon-button (click)="toggleSampleTypeFilter()">
                                                    <mat-icon>close</mat-icon>
                                                </button>
                                            </div>
                                            <mat-selection-list [(ngModel)]="sampleTypeSelectedOptions" (ngModelChange)="sampleTypeSelectionChange($event)">
                                                <mat-list-option (click)="selectAllSampleTypes()" checkboxPosition="before" [value]="'all'">Show all</mat-list-option>
                                                <mat-divider></mat-divider>
                                                <mat-list-option checkboxPosition="before" *ngFor="let typeId of sampleTypes" [value]="typeId">
                                                    <div class="sample-type" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="4px">
                                                        <img class="sample-type-img" [src]="sampleTypeImage(typeId) | safe : 'url'" alt="" srcset="" />
                                                        <div class="sample-type-text">{{ sampleTypeLabel(typeId) }}</div>
                                                    </div>
                                                </mat-list-option>
                                            </mat-selection-list>
                                        </div>
                                    </ng-template>
                                </mat-header-cell>
                                <mat-cell fxHide.xs="true" *matCellDef="let element" class="table-body">
                                    <div fxLayout="column" fxLayoutGap="4px">
                                        <div *ngFor="let sampleTypeId of parseSampleTypes(element.sampleTypes)">
                                            <a class="sample-type"
                                               fxLayout="row"
                                               fxLayoutAlign="start center"
                                               fxLayoutGap="4px"
                                               [routerLink]="['/explore/type', sampleTypeId, 'ref', element.refId]"
                                               routerLinkActive="router-link-active">
                                                <img class="sample-type-img" [src]="sampleTypeImage(sampleTypeId) | safe : 'url'" alt="" srcset="" />
                                                <div class="sample-type-text">{{ sampleTypeLabel(sampleTypeId) }}</div>
                                            </a>
                                        </div>
                                    </div>
                                </mat-cell>
                            </ng-container>

                            <!-- Download -->
                            <ng-container matColumnDef="download">
                                <mat-header-cell fxHide.lt-sm="true" *matHeaderCellDef class="fw-bold">
                                    Download
                                </mat-header-cell>

                                <mat-cell fxHide.lt-sm="true" *matCellDef="let element" class="table-body">

                                    <a class="download-csv"
                                       fxLayout="row"
                                       fxLayoutAlign="start center"
                                       fxLayoutGap="4px"
                                       (click)="openDialog(element.refId);$event.preventDefault()"
                                       href='/datasets/{{element.refId}}.csv'
                                       routerLinkActive="router-link-active">
                                        <span class="download-csv-text">CSV</span>

                                    </a>&nbsp;&nbsp;&nbsp;

                                    <a *ngIf="showNetCDFbutton(element.refId)" class="download-csv" style="background: darkcyan;color:white;"
                                       fxLayout="row"
                                       fxLayoutAlign="start center"
                                       fxLayoutGap="4px"
                                       (click)="openNETCDFDialog(element.refId);$event.preventDefault()"
                                       href='/datasets/{{element.refId}}.nc'
                                       routerLinkActive=router-link-active>

                                        <span class="download-csv-text">NetCDF</span>
                                    </a>



                                </mat-cell>
                            </ng-container>

                            <!-- Download -->


                            <mat-header-row fxLayout.lt-sm="row" fxLayoutAlign.lt-sm="space-between center" *matHeaderRowDef="displayedColumns"></mat-header-row>
                            <mat-row fxLayout="row" fxLayoutAlign="start start" *matRowDef="let row; columns: displayedColumns"></mat-row>
                        </mat-accordion>
                    </mat-table>
                </div>

            <div fxLayout="row" fxLayoutAlign="center center">
                <button [disabled]="disableLoadMore" class="load-more-button px-5" mat-button color="primary" (click)="loadMoreDatasets()">Load more datasets</button>
            </div>
            <div id="container" *ngIf="showDialog" class="display-dialog">
                <div class="dialog">
                    <div *ngComponentOutlet="activeComponent"></div>
                </div>
            </div>
        </div>
    </div>
</div>

